/* eslint-disable camelcase */
import { EVENTS } from './tracking';
import { getTrackingStats } from '../services/tracking';
import * as logger from './logger';
import {
    useAuth,
} from '../stores/auth-store';
import { useProfile } from '../stores/profile-store';

export function makeGA4Tracker() {
    window.dataLayer = window.dataLayer || [];

    return {
        enable(gtm) {
            // Loading of GTM could be blocked (e.g., by an ad blocker).
            if (!gtm) return;

            gtm.enable(true);
        },
        event({
            event = 'click_element',
            element = null,
            elementDetail = null,
            funnelType = null,
            funnelStep = null,
            funnelVariant = null,
            jobId = null,
            applicationType = null,
            userData = null,
            jobType = null,
            productType = null,
            ...unexpectedExtraParams
        } = {}) {
            if (Object.keys(unexpectedExtraParams).length > 0) {
                // eslint-disable-next-line no-console
                console.warn(
                    'GA4 tracking called with unexpected parameters, these are not pushed into the ' +
                    'dataLayer and subsequently are not properly tracked! Unhandled parameters:',
                    Object.keys(unexpectedExtraParams).join(', '),
                );
            }

            window.dataLayer.push({
                event,
                element,
                element_detail: elementDetail,
                funnel_type: funnelType,
                funnel_step: funnelStep,
                funnel_variant: funnelVariant,
                job_id: jobId,
                job_type: jobType,
                product_type: productType,
                application_type: applicationType,
                user_data: userData,
            });
        },
        trackABTest({ name, variant }) {
            window.dataLayer.push({
                event: EVENTS.abTest,
                ab_test_name: name,
                ab_test_variant: variant,
            });
        },
        trackVisibility({ element = null, elementDetail = null }) {
            if (import.meta.env.MODE === 'development' && element === null) {
                // eslint-disable-next-line no-console
                console.warn('No element for GA4 visibility tracking defined');
            }
            window.dataLayer.push({
                event: EVENTS.trackVisibility,
                element,
                // eslint-disable-next-line camelcase
                element_detail: elementDetail,
            });
        },
        async trackUser() {
            try {
                const auth = useAuth();
                const profile = useProfile();
                const userUuid = auth.uuid;
                const userType = userUuid ? 'user' : 'guest';
                const tracking = userUuid ? await getTrackingStats() : null;

                window.dataLayer.push({
                    ...tracking,
                    event: EVENTS.userdata,
                    userType,
                    userTypeDetail: profile.userTypeDetail,
                    userId: userUuid,
                });
            } catch (exception) {
                logger.warning({
                    exception,
                    message: 'Failed to track user data.',
                });
            }
        },
        trackVirtualPageView({ pageUrl, pageTitle }) {
            window.dataLayer.push({
                event: EVENTS.pageView,
                pageUrl,
                pageTitle,
            });
        },
    };
}
/* eslint-enable camelcase */
